export interface IServiceOption {
  name: string;
  productId: string;
  priceId: string;
  description: string;
  amount: number;
  currency: string;
}

export const TEST_SERVICE_OPTIONS: IServiceOption[] = [
  {
    name: 'Housekeeping Basic Service',
    productId: 'prod_L3A0SVSSVcU6Ox',
    priceId: 'price_1KN3gJGplLfnv6vWfpb7j1jR',
    description: 'Seattle Price',
    amount: 1000,
    currency: 'USD'
  }
];

export const PRODUCTION_SERVICE_OPTIONS: IServiceOption[] = [];

